// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export * from "./indexPlatform-browser.mjs";
